import styled from 'styled-components/macro'

const Image = styled.img`
  width: 25px;
  height: 25px;
`

export { Image }
